import { initialUpperCase } from '@op/utils';

export function translateText(
  text: string,
  type: 'posts' | 'views' | 'engagement',
  formatMessage = (text: string, oriText?: string) => text,
) {
  const newText = initialUpperCase(text);
  if (type === 'posts') {
    if (!['total', 'video', 'stream'].includes(text)) {
      return formatMessage(newText + ' ' + initialUpperCase(type));
    } else if (text === 'stream') {
      return formatMessage('Stream Sessions');
    }
  }
  return formatMessage(initialUpperCase(text), text);
}
